'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'cake-candles';
var width = 448;
var height = 512;
var aliases = [127874,"birthday-cake","cake"];
var unicode = 'f1fd';
var svgPathData = 'M383.1 223.1L376 224V168c0-13.25-10.75-24-24-24s-24 10.75-24 24V224h-80V168c0-13.25-10.75-24-24-24S200 154.8 200 168V224h-80V168C120 154.8 109.3 144 96 144S72 154.8 72 168V224L64 223.1c-35.35 0-64 28.65-64 63.1v192C0 497.7 14.33 512 32 512h384c17.67 0 32-14.33 32-32V287.1C448 252.6 419.3 223.1 383.1 223.1zM400 464h-352v-71.57c18.12-2.906 34.43-10.33 48-19.1c17.34 11.19 39.64 21.37 64 21.37s46.66-10.19 64-21.37c17.34 11.19 39.64 21.37 64 21.37s46.66-10.19 64-21.37c13.46 8.68 29.94 16.68 48 19.82V464zM400 343.8c-13.47-4.363-25.79-12.82-33.05-18.58c-8.75-6.969-21.16-6.969-29.91 0C326.1 333.2 307.2 346.7 288 346.7s-38.97-13.47-49.05-21.48c-8.75-6.969-21.16-6.969-29.91 0C198.1 333.2 179.2 346.7 160 346.7s-38.97-13.47-49.05-21.48c-8.75-6.969-21.16-6.969-29.91 0C73.79 330.1 61.47 339.4 48 343.8V288c0-8.822 7.178-16 16-16h320c8.822 0 16 7.178 16 16V343.8zM352 111.1c22.09 0 40-17.88 40-39.97S352 0 352 0s-40 49.91-40 72S329.9 111.1 352 111.1zM224 111.1c22.09 0 40-17.88 40-39.97S224 0 224 0S184 49.91 184 72S201.9 111.1 224 111.1zM96 111.1c22.09 0 40-17.88 40-39.97S96 0 96 0S56 49.91 56 72S73.91 111.1 96 111.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCakeCandles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;